<div class="period-capacity-cell-renderer"
  (click)="toggleExpand()">
  <al-progress-bar [value]="plannedHours"
    [maxValue]="capacity"
    [isPercent]="false"
    [isLoading]="isLoading"
    [status]="status">
    <div main>
      @if (isOverloaded) {
        <fa-icon
          [icon]="['fas', 'warning']"
          [matTooltipDisabled]="!resource?.name"
          [matTooltip]="'resource-management.planningBoard.tooltips.overloadedPeriodWarning' | translate: {resourceName:resource?.name}" />
      }
    </div>
    @if (planningSettings) {
      <div class="remaining-capacity-bar"
        >
        @if (percentProgress < 100 && capacity) {
          <span
            [attr.planned-hours]="plannedHours"> {{(capacity - plannedHours) | formatNumber}}
          </span>
        }
        @if (!capacity && !plannedHours) {
          <fa-icon
            [icon]="['fas', 'umbrella-beach']"
            [matTooltipDisabled]="!resource?.name"
            [matTooltip]="'resource-management.planningBoard.tooltips.fullTimeoffPeriodInfo' | translate: {resourceName:resource?.name}" />
        }
      </div>
    }
  </al-progress-bar>

  <al-period-sums [isVisible]="node?.expanded"
    [plannedHours]="plannedHours" />
  </div>

  <al-cell-drop-zone [node]="node"
    [period]="period?.hasActualHours ? undefined : period"
    (dragOverDelay)="expand()" />
